import { createContext, useReducer } from 'react'
import { reducer } from './Reducer';

export const GlobalContext = createContext("Initial Value");

let data = {
    clickLoad: false,
    darkTheme: true,
    user: {},
    ramzanPopup:{},
    isLogin: null,
    token:"",
    saleToken:"",
    saleIsLogin: false,
    ipAddress: "",
    reloadTime: null,
    reloadToggle: false,
    baseUrl: "https://vpserver.org/HRMS-v3-b/",
    baseUrl2: "https://vpserver.org/sale-system/api/",
    mainPageLoad: false,
    basePath: "",
    userList : [],
    getDropdowns: {},
    coverPhotos: [],
    timeIn: "",
    timeOut: "",
    hrs: "",
    timeLoader: false
    // basePath: "/new-dashboard" //For Live
}

export default function ContextProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, data);
    const reloadSetTime = () => {
        dispatch({type: "UPDATE_RELOAD_TIME"})
    }
    return (
        <GlobalContext.Provider value={{ state, dispatch, reloadSetTime }}>
            {children}
        </GlobalContext.Provider>
    )
}